export default __webpack_public_path__ + "images/427a1c99b096a6f03531dbfa98ae08dc-gold-ring.svg";